import { render, staticRenderFns } from "./ModalAbilities.vue?vue&type=template&id=67f14feb"
import script from "./ModalAbilities.vue?vue&type=script&lang=js"
export * from "./ModalAbilities.vue?vue&type=script&lang=js"
import style0 from "./ModalAbilities.vue?vue&type=style&index=0&id=67f14feb&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports